import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';
import RouterUtils from '../../shared/routing/RouterUtils';

export default class UserRequest extends GenericRequest {

    constructor(id) {
        super(METHOD_GET, RouterUtils.generateRoute(ApiEndpoints.USER_ID, { id: id }));
    }

}



// WEBPACK FOOTER //
// ./src/app/users/ws/UserRequest.js